export default "__VITE_ASSET__81e99d2e__"